import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { makeStyles } from '@mui/styles';
import { storeKrunica } from '../store/KrunicaStore';
import Amen from './Amen';

const useStyles = makeStyles((theme) => ({
  opisMolitve: {
    justifyContent: 'space-between',
    marginTop: '0.5rem',
    textAlign: 'center',
    fontSize: '1.6rem',
    [theme.breakpoints.up('sm')]: {
      backgroundColor: '#e9e9e9',
      color: '#093145',
      border: '1px solid #ece7e7',
      width: '50%',
      margin: 'auto',
      fontSize: '2rem',
    },
  },
}));

function OceNas() {
  const classes = useStyles();
  const {
    aktivnaZemlja: { oceNas, oceNasText, krunice },
    trenutnaKrunica,
    zrno,
  } = storeKrunica;

  return (
    <Fragment>
      <div className={classes.opisMolitve}>
        <div>
          {trenutnaKrunica === 'rita' &&
            zrno === 6 &&
            krunice.find((k) => k.value === trenutnaKrunica)?.otajstvo1}
          {trenutnaKrunica === 'rita' &&
            zrno === 17 &&
            krunice.find((k) => k.value === trenutnaKrunica)?.otajstvo2}
          {trenutnaKrunica === 'rita' &&
            zrno === 28 &&
            krunice.find((k) => k.value === trenutnaKrunica)?.otajstvo3}
          {trenutnaKrunica === 'rita' &&
            zrno === 39 &&
            krunice.find((k) => k.value === trenutnaKrunica)?.otajstvo4}
          {trenutnaKrunica === 'rita' &&
            zrno === 50 &&
            krunice.find((k) => k.value === trenutnaKrunica)?.otajstvo5}
        </div>
        <div style={{ marginTop: 15 }}>
          <strong>{oceNas}</strong>
          {oceNasText}
        </div>
        <Amen />
      </div>
    </Fragment>
  );
}

export default observer(OceNas);
